import { X } from 'lucide-react';
import type { KeyboardEvent } from 'react';

import { Button } from '~/components/shadcn/button.tsx';
import { useTranslations } from '~/i18n/use-translations.ts';
import { cn } from '~/utils/cn';

type ButtonCloseProps = {
	className?: string;
	iconClassName?: string;
	onClose: () => void;
};

export function ButtonClose({ className, iconClassName, onClose }: ButtonCloseProps) {
	const t = useTranslations();
	return (
		<Button
			className={cn('text-foreground', className)}
			onClick={onClose}
			onKeyDown={(e: KeyboardEvent<HTMLButtonElement>) => e.key === 'Enter' && onClose()}
			size="icon"
			type="button"
			variant="outline"
		>
			<X className={cn('size-4', iconClassName)} />
			<span className="sr-only">{t('common.close')}</span>
		</Button>
	);
}
